import Position from './position';

export default class InputManager {

	constructor(args) {
		this.system = args.system;
		this.mousePresent = false; // assume touchscreen until proven otherwise
		this.touchOffset = new Position();
		this.keyLocks = {}; // prevent system key repeat
	}

	init() {
		// register keypresses globally
		window.addEventListener('keydown', this.onKeyDown.bind(this));
		window.addEventListener('keyup', this.onKeyUp.bind(this));

		// only register certain touch/pointer events within the game canvas
		let canvas = this.system.display.renderer.view;
		canvas.addEventListener('pointerdown', this.onPointerDown.bind(this));
		canvas.addEventListener('touchstart', this.onTouchStart.bind(this));
		canvas.addEventListener('touchmove', this.onTouchMove.bind(this));
		canvas.addEventListener('touchend', this.onTouchEnd.bind(this));
		canvas.addEventListener('touchcancel', this.onTouchCancel.bind(this));
		
		// allow pointer movement & finishing events to register outside of the game canvas
		window.addEventListener('pointermove', this.onPointerMove.bind(this));
		window.addEventListener('pointerup', this.onPointerUp.bind(this));
	}


	// keyboard
	remoteKey(key) {
		// spoof a keypress
		this.onKeyDown({key:key});
		this.onKeyUp({key:key});
	}
	onKeyUp(e) {
		this.keyLocks[e.key] = false;
		this.system.sceneManager.currentScene.onKeyUp(e.key);
	}
	onKeyDown(e) {
		if(this.keyLocks[e.key]) return;
		this.keyLocks[e.key] = true;
		this.system.sceneManager.currentScene.onKeyDown(e.key);
	}


	// mouse events
	// technically mouse+touch, but proper touch-identified events
	// are ignored here, to cover weird browser edge cases
	onPointerMove(e) {
		if(e.pointerType == 'touch') return;
		if(!this.system.sceneManager.currentScene) return;
		if(this.system.sceneManager.currentScene.destroyed) return;
		this.mousePresent = true; // mouse confirmed https://www.youtube.com/watch?v=qcR3U77nPv4
		e = this.offsetCanvasEventCoords(e);
		let c = this.system.screen.getCoords(e.x, e.y);
		this.system.sceneManager.currentScene.onPointerMove(c, 0);
	}
	onPointerDown(e) {
		if(e.pointerType == 'touch') return;
		if(this.system.sceneManager.currentScene.destroyed) return;
		let c = this.system.screen.getCoords(e.offsetX, e.offsetY);
		this.system.sceneManager.currentScene.onPointerDown(c, 0);
	}
	onPointerUp(e) {
		if(e.pointerType == 'touch') return;
		if(this.system.sceneManager.currentScene.destroyed) return;
		e = this.offsetCanvasEventCoords(e);
		let c = this.system.screen.getCoords(e.x, e.y);
		this.system.sceneManager.currentScene.onPointerUp(c, 0);
	}

	offsetCanvasEventCoords(e) {
		// account for canvas offset
		return {
			x: e.clientX - this.system.display.renderer.view.offsetLeft,
			y: e.clientY - this.system.display.renderer.view.offsetTop,
		};
	}


	// touchscreen events
	translateTouchEventCoords(e) {
		return this.system.screen.getCoords(
			e.changedTouches[0].clientX - this.touchOffset.x,
			e.changedTouches[0].clientY - this.touchOffset.y
		);
	}
	onTouchStart(e) {
		// store container offset until next touch event begins
		let r = e.srcElement.getBoundingClientRect();
		this.touchOffset.x = r.left;
		this.touchOffset.y = r.top;
		// pass coords through to scene as mousedown
		this.system.sceneManager.currentScene.onPointerDown(
			this.translateTouchEventCoords(e),
			e.changedTouches[0].identifier
		);
	}
	onTouchMove(e) {
		// pass coords through to scene as mousemove
		this.system.sceneManager.currentScene.onPointerMove(
			this.translateTouchEventCoords(e),
			e.changedTouches[0].identifier
		);
	}
	onTouchEnd(e) {
		// pass coords through to scene as mouseup
		this.system.sceneManager.currentScene.onPointerUp(
			this.translateTouchEventCoords(e),
			e.changedTouches[0].identifier
		);
	}
	onTouchCancel(e) {
		// ¯\_(ツ)_/¯
		this.onTouchEnd(e);
	}


}